// getImageUrl.js
// Versi "React-friendly" dari logic ParserImage.js.
// ParserImage.js bekerja di DOM (scan elemen img/a hasil raw HTML dari CMS),
// sedangkan komponen seperti Gallery render img dari data React biasa,
// jadi butuh fungsi transform string, bukan DOM observer.
//
// Aturan disamakan dengan ParserImage.js supaya konsisten:
// - Hanya di-encode kalau memang file asset yang dikenali (isAssetFile)
// - URL yang sudah absolut (http/https) TIDAK disentuh
// - Encode pakai safeBase64Encode yang tidak crash untuk karakter unicode/aneh
import { encode as base64Encode } from "base-64";
import global from "../../config"; // sesuaikan kedalaman path sesuai lokasi file ini

const assetExtensions = [".jpg", ".jpeg", ".png", ".gif", ".svg", ".webp"];

function safeBase64Encode(str) {
    try {
        return base64Encode(unescape(encodeURIComponent(str)));
    } catch (err) {
        console.error("Gagal encode base64 untuk:", str, err);
        return null;
    }
}

const isAssetFile = (url) => {
    if (!url) return false;
    const clean = url.split(/[?#]/)[0].toLowerCase();
    return assetExtensions.some((ext) => clean.endsWith(ext));
};

/**
 * Resolve path gambar mentah dari API jadi URL siap-pakai.
 * @param {string} path - nilai mentah dari backend (mis. val.feature_image)
 * @param {string} [fallback] - dipakai kalau path kosong / gagal encode
 * @returns {string}
 */
export default function resolveImageUrl(path, fallback = "") {
    if (!path) return fallback;

    // Sudah URL absolut (http/https) -> jangan diutak-atik
    if (/^https?:\/\//i.test(path)) return path;

    // Bukan file gambar yang dikenali -> biarkan apa adanya, jangan dipaksa encode
    if (!isAssetFile(path)) return fallback || path;

    const encoded = safeBase64Encode(path.replaceAll("%20", " "));
    if (!encoded) return fallback || path;

    return `${global?.config?.backend ?? ""}/api/getimage/${encoded}`;
}